import { ArrowRight } from 'lucide-react';
import { trackAssessmentClick } from '../../lib/analytics';

export const RedesignHero = () => (
  <section className="hero" id="top">
    <div className="container hero-grid">
      <div>
        <h1><span className="hero-kicker">Pniel Analytics</span> Stop stitching reports.<span className="hero-accent"> Start making executive decisions.</span></h1>
        <p className="hero-copy">
          Pniel Analytics transforms fragmented business data into automated Tableau and Power BI
          dashboards that drive faster, confident decisions.
        </p>
        <div className="actions">
          <a className="button" href="/analytics-assessment" onClick={() => trackAssessmentClick('hero')} data-testid="hero-book-btn">
            Book a Free Analytics Assessment <ArrowRight className="w-4 h-4" />
          </a>
          <a className="button secondary" href="/case-studies" data-testid="hero-cases-btn">View Dashboard Case Studies</a>
        </div>
        <p className="hero-microcopy" data-testid="hero-microcopy">Free &middot; 30 minutes &middot; no obligation</p>
        <div className="proof">
          <span>10+ Projects Delivered</span>
          <span>Tableau &amp; Power BI &middot; SQL</span>
          <span>SAM-Registered Small Business</span>
        </div>
      </div>

      <div className="dashboard-shell dashboard-shell-img">
        <picture>
          <source
            type="image/webp"
            srcSet="/hero-dashboard-640.webp 640w, /hero-dashboard-1024.webp 1024w, /hero-dashboard-1600.webp 1600w"
            sizes="(max-width: 980px) 90vw, 600px"
          />
          <img
            src="/hero-dashboard.png"
            alt="Retail Performance Overview, executive sales and profitability dashboard by Pniel Analytics"
            className="dashboard-img"
            width="1600"
            height="1035"
            fetchPriority="high"
            decoding="async"
          />
        </picture>
      </div>
    </div>
  </section>
);
